import styles from './Spinner.module.css';

export function Spinner() {
  return (
    <div className="w-full h-full flex justify-center items-center">
      <div className={styles['loadingio-spinner-ellipsis-2by998twmg8']}>
        <div className={styles['ldio-yzaezf3dcmj']}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
}
